export enum Sizing {
  none = '0px',
  xs = '4px',
  sm = '8px',
  md = '12px',
  lg = '16px',
  xl = '32px',
}
